import { Text, Tooltip, type TextProps } from "@mantine/core";
import type { ReactNode } from "react";
import classes from "./PersonName.module.css";

/**
 * A person's name; an archived one is shown in orange and says so on hover.
 * Pass hint={false} where an outer tooltip already mentions the archive.
 */
export function PersonName({ archived, hint = true, children, ...props }: TextProps & { archived?: boolean | null; hint?: boolean; children: ReactNode }) {
  const name = <Text fz="sm" {...props} className={archived ? classes.archived : undefined}>{children}</Text>;
  return archived && hint ? <Tooltip label="В архиве" withArrow openDelay={300}>{name}</Tooltip> : name;
}
